import React from "react";
import {Box, Button, IconButton, Stack, TextField, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Add01Icon, Delete02Icon} from "@hugeicons/core-free-icons";
import {v4 as uuidv4} from "uuid";
import {menuItemsInfo} from "../editMenuItems";
import {UI, rgba} from "../../uiTokens";
import {fieldSx, iconBtnDangerSx, sectionLabelSx} from "../editMenuStyles";
import {SectionHeader} from "../components/EditMenuSection";

export const InputArgsTab = ({node, setNode, onUpdate}) => {
    const onChangeInputArg = (uid, field, value) => {
        setNode(prev => {
            const state = {...prev};
            if (!state?.data?.input_args) {
                state.data.input_args = [];
            }
            const inputIndex = state.data.input_args.findIndex(input => input.uid === uid);
            if (inputIndex !== -1) {
                state.data.input_args[inputIndex][field] = value;
            }
            return state;
        });
    };

    const onUpdateInputArg = () => {
        onUpdate(node);
    };

    const removeInputArg = (uid) => {
        setNode(prev => {
            const state = {...prev};
            if (state?.data?.input_args) {
                state.data.input_args = state.data.input_args.filter(input => input.uid !== uid);
            }
            return state;
        });
        onUpdate(node);
    };

    const addMessage = () => {
        setNode(prev => {
            const state = {...prev};
            if (!state?.data?.input_args) {
                state.data.input_args = [];
            }
            state.data.input_args = [...state.data.input_args, {uid: uuidv4(), name: "", value: ""}];
            return state;
        });
        onUpdate(node);
    };

    const {primary, secondary} = menuItemsInfo.input_args;
    const args = node?.data?.input_args || [];

    return (
        <>
            <SectionHeader title={primary} description={secondary}/>

            {args.length === 0 && (
                <Typography sx={{fontSize: 12, color: rgba(UI.muted, 0.85)}}>No input arguments yet.</Typography>
            )}

            <Stack gap={1}>
                {args.map((inputArg, index) => (
                    <Box
                        key={inputArg.uid}
                        sx={{p: 1, borderRadius: "10px", border: `1px solid ${rgba(UI.ink, 0.1)}`, backgroundColor: UI.surface}}
                    >
                        <Stack direction="row" alignItems="center" sx={{mb: 0.5}}>
                            <Typography sx={{...sectionLabelSx, flex: 1}}>Argument {index + 1}</Typography>
                            <Tooltip title="Delete argument" disableInteractive>
                                <IconButton size="small" sx={iconBtnDangerSx} onClick={() => removeInputArg(inputArg.uid)}>
                                     <HugeiconsIcon icon={Delete02Icon} size={15}/>
                                </IconButton>
                            </Tooltip>
                        </Stack>
                        <Stack gap={1}>
                            <TextField
                                value={inputArg.name}
                                size="small"
                                placeholder="Input name..."
                                label="Name"
                                sx={fieldSx}
                                onChange={e => onChangeInputArg(inputArg.uid, "name", e.target.value)}
                                onBlur={() => onUpdateInputArg()}
                            />
                            <TextField
                                value={inputArg.value}
                                size="small"
                                placeholder="Input value..."
                                label="Value"
                                sx={fieldSx}
                                onChange={e => onChangeInputArg(inputArg.uid, "value", e.target.value)}
                                onBlur={() => onUpdateInputArg()}
                            />
                        </Stack>
                    </Box>
                ))}
            </Stack>

            <Button
                size="small"
                startIcon={<HugeiconsIcon icon={Add01Icon} size={15}/>}
                onClick={addMessage}
                sx={{
                    alignSelf: "flex-start",
                    textTransform: "none",
                    fontWeight: 600,
                    borderRadius: "8px",
                    color: UI.accent,
                    "&:hover": {backgroundColor: rgba(UI.accent, 0.1)},
                }}
            >
                Add input
            </Button>
        </>
    );
};
